import React from "react";
import { Typography, Row, Col, Divider } from "antd";
import CouponContainer from "../Coupon/CouponContainer";
import { friendlyPrice, getPlanInterval, friendlyNumber } from "../../../utils/calculators";
import { INBOUND, OUTBOUND, index, TRANSACTIONAL_API } from "../../../utils/constants";
import { useConfigContext } from "../../../context/ConfigContext";

const { Text } = Typography;

const convertFeatureValue = (plan, productHandle, featureValues) => {
    if (!plan || !productHandle) {
        return null;
    }
    switch (productHandle) {
        case INBOUND:
            if (!featureValues) return null;
            const key = Object.keys(featureValues)[0]; //right now every plan only have one feature
            return {
                value: featureValues[key],
                unit: featureValues[key] > 1 ? "domains" : "domain",
            };

        case OUTBOUND:
            return {
                value: plan.includedEmails,
                unit: plan.includedEmails > 1 ? "emails" : "email",
            };

        default:
            return null;
    }
};

const getChangePlanLink = (productHandle, emailApiPricingPlansWebsiteUrl) => {
    if (productHandle === TRANSACTIONAL_API) {
        return emailApiPricingPlansWebsiteUrl;
    }
    return index;
}

const SubscriptionDetail = props => {
    const { itemDetails, showCoupon } = props;
    if (!itemDetails) return null;

    const {
        config: {
            emailApiPricingPlansWebsiteUrl
        }
    } = useConfigContext()

    const {
        summary,
        id,
        productHandle,
        featureValues,
        plan: { planName, billingIntervalType, descriptions },
        couponCodes,
    } = itemDetails;
    const { subtotal, discount, billingPeriod } = summary;

    const friendlyFeatureValues = convertFeatureValue(
        itemDetails.plan,
        productHandle,
        featureValues
    );

    const changePlanLink = getChangePlanLink(productHandle, emailApiPricingPlansWebsiteUrl);
    return (
        <div>
            <Row type="flex" justify="space-between" align="middle">
                <Col>
                    <div>
                        <Text strong style={{ fontSize: "1rem" }}>
                            {planName}
                        </Text>
                        <a href={changePlanLink}>{` change plan?`}</a>
                    </div>
                </Col>
                <Col>
                    <Text strong style={{ fontSize: "1rem" }}>
                        {`${friendlyPrice(subtotal / billingPeriod)}/${getPlanInterval(billingIntervalType)}`}
                    </Text>
                </Col>
            </Row>

            <ul
                style={{
                    listStyleType: "none",
                    padding: "4px 0",
                    marginTop: "0.5rem",
                    color: "rgba(0,0,0,0.5)",
                }}
            >
                {friendlyFeatureValues && (
                    <li>
                        <Text strong>{`${friendlyNumber(friendlyFeatureValues.value)}`}</Text>
                        <Text type="secondary">{` ${friendlyFeatureValues.unit} included`}</Text>
                    </li>
                )}
                {descriptions &&
                    descriptions.map((description, index) => (
                        <li key={"description" + index}>{description}</li>
                    ))}
            </ul>

            {showCoupon && (
                <CouponContainer
                    key={id}
                    itemId={id}
                    handle={productHandle}
                    usedCoupons={couponCodes}
                />
            )}
            {/** subscription discount  */}
            {discount > 0 && (
                <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    style={{ paddingTop: "1em" }}
                >
                    <Col>
                        <Text strong>{`Discount Amount:`}</Text>
                    </Col>
                    <Col>
                        <Text strong>{`-${friendlyPrice(discount)}`}</Text>
                    </Col>
                </Row>
            )}
            <Divider />
        </div>
    );
};

export default SubscriptionDetail;
